import { environment } from '@environment';

export const USER_ID = 'user_id';
export const LOYALTY_LEVEL = 'loyalty_level';
export const IS_PRIME = 'is_prime';
export const IS_MOBILE = 'is_mobile';
export const TREATMENTS = 'treatments';
export const LEVEL_PRIME = 'level_prime';

export const homeApi = {
  home_data: `${environment.api.travel_cms}/page?pagecode={pageCode}`+
  `&${IS_MOBILE}={isMobile}&${USER_ID}={userId}&${IS_PRIME}={isPrime}&${LOYALTY_LEVEL}={loyalty}&`+
  `${TREATMENTS}={treatments}&${LEVEL_PRIME}={levelPrime}`,
};
